import type { ListingAvailability } from '@bb/domain/dist/types';

export const MLS_TYPE_LABEL_MAP: Partial<Record<string, string>> = {
  TREB: 'PropTx',
  SMLS: 'SmartMLS',
  RECO: 'Recolorado',
  NONE: 'No Parent MLS',
};

export const availabilityOrder: ListingAvailability[] = [
  'New',
  'Extended',
  'Price Change',
  'Deal Fell Through',
  'Sold Conditionally',
  'Leased Conditionally',
  'Sold',
  'Leased',
  'Expired',
  'Terminated',
  'Suspended',
];
